import type { ContractResultData } from 'gql/graphql';
import { ContractOtherStatusEnum } from 'gql/graphql';
import { Badge } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';

import Style from './NameCellRenderer.module.css';

export const NameCellRenderer: React.FC<ICellRendererParams<ContractResultData>> = (props) => {
    const { data } = props;

    return (
        <div className={Style.name}>
            {data?.otherCostStatus === ContractOtherStatusEnum.NewRecord && (
                <Badge size="s" status="normal" className={Style.badge} />
            )}
            {data?.name}
        </div>
    );
};

NameCellRenderer.displayName = 'NameCellRenderer';
